<template>
  <router-view />
</template>

<style>
:root {
  --black: #000;
  --white: #fff;
  --n-950: #0a0a0a;
  --n-900: #111;
  --n-800: #1a1a1a;
  --n-700: #2b2b2b;
  --n-600: #4a4a4a;
  --n-500: #737373;
  --n-400: #a3a3a3;
  --n-300: #d4d4d4;
  --n-200: #e5e5e5;
  --n-100: #f3f3f3;
  --n-50: #fafafa;

  --bg: #fff;
  --bg-secondary: #f5f5f5;
  --bg-dark: #111326;

  --text: #1d1b32;
  --text-secondary: #625e73;
  --text-muted: #707070; /* 4.9:1 on #fff, 4.5:1 on #f5f5f5 (spec #909090 fails AA) */
  --text-inverse: #fff;
  --text-inverse-secondary: rgba(255, 255, 255, 0.72);

  --border-light: rgba(0, 0, 0, 0.08);
  --border-medium: rgba(0, 0, 0, 0.14);
  --border-dark: rgba(255, 255, 255, 0.14);

  --font-display: "Avenir Next", "Segoe UI", "Helvetica Neue", sans-serif;
  --font: "Helvetica Neue", Arial, system-ui, -apple-system, BlinkMacSystemFont,
    sans-serif;

  --ease-out: cubic-bezier(0.22, 1, 0.36, 1);
  --ease: cubic-bezier(0.4, 0, 0.2, 1);

  --container: 1280px;
  --gutter: 48px;
  --section-y: 112px;
  --nav-h: 72px;
}

@media (max-width: 1199px) {
  :root {
    --gutter: 32px;
    --section-y: 100px;
  }
}

@media (max-width: 767px) {
  :root {
    --gutter: 20px;
    --section-y: 72px;
    --nav-h: 64px;
  }
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
  scroll-padding-top: var(--nav-h);
  -webkit-text-size-adjust: 100%;
}

body {
  margin: 0;
  background: var(--bg);
  color: var(--text);
  font-family: var(--font);
  font-size: 16px;
  line-height: 1.6;
  font-feature-settings: "cv11", "ss01";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

h1,
h2,
h3,
p {
  margin: 0;
}

a {
  color: inherit;
  text-decoration: none;
}

button {
  font: inherit;
  color: inherit;
}

img,
svg {
  display: block;
}

:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: 3px;
}

.container {
  width: 100%;
  max-width: var(--container);
  margin: 0 auto;
  padding-left: var(--gutter);
  padding-right: var(--gutter);
}

.eyebrow {
  font-size: 13px;
  line-height: 1.4;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-muted);
}

main:focus {
  outline: none;
}

.skip-link {
  position: fixed;
  top: 12px;
  left: 12px;
  z-index: 100;
  padding: 10px 16px;
  border-radius: 999px;
  background: var(--n-900);
  color: #fff;
  font-size: 14px;
  transform: translateY(-200%);
  transition: transform 180ms ease;
}

.skip-link:focus {
  transform: none;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.reveal {
  opacity: 0;
  transform: translateY(32px);
  transition: opacity 700ms var(--ease-out), transform 700ms var(--ease-out);
  transition-delay: var(--reveal-delay, 0ms);
}

.reveal-visible {
  opacity: 1;
  transform: none;
}

@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }
  .reveal {
    transform: none;
    transition: opacity 300ms linear;
  }
  *,
  *::before,
  *::after {
    animation-duration: 1ms !important;
    animation-iteration-count: 1 !important;
  }
}
</style>

<style>
@media print {
  .nav,
  .skip-link,
  .footer {
    display: none !important;
  }
  :root {
    --gutter: 0px;
  }
  body {
    background: white;
    color: black;
  }
}
</style>
